export const reloadPage = () => window.location.reload();

export const getCurrentPageUrl = () => {
  return new URL(window.location.href);
};

export const go = href => {
  window.location.href = href;
};

export const reload = () => {
  window.location.reload();
};

export const getSearchParam = key => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

export const getLastPathParam = () => {
  const pathParts = window.location.pathname.split("/");
  return pathParts[pathParts.length - 1];
};

export const origin = () => {
  return new URL(window.location.origin);
};
